import EyeDrawSection from '../EyeDrawSection';
import thumb14 from '../images/thumb_14.jpg';
import thumb15 from '../images/thumb_15.jpg';
import thumb16 from '../images/thumb_16.jpg';
import img14 from '../images/14.png';
import img15 from '../images/15.png';
import img16 from '../images/16.png';

const cards = [
    { title: 'Cornea/Sclera - Episcleritis', thumb: thumb14, image: img14 },
    { title: 'Cornea/Sclera - Neovascularization', thumb: thumb15, image: img15 },
    { title: 'Cornea/Sclera - Scleritis', thumb: thumb16, image: img16 },
];

export default function Cornea() {
    return <EyeDrawSection id="cornea-sclera" title="Cornea/Sclera" icon="bi-circle" cards={cards} />;
}
